// Syndicates are single-word identifiers; map any that need a better display name
const SYNDICATE_DISPLAY_NAMES: Record<string, string> = {
  CNAHARDY: "CNA HARDY",
}

export const formatSyndicate = (syndicate: string): string =>
  SYNDICATE_DISPLAY_NAMES[syndicate] ?? syndicate
